import { createPlatformSiteAri } from '@townsquare/collab-context/create-site-ari';
import { getStandardColumns } from '@townsquare/columns/hooks/use-shown-columns';
import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import TeamDirectoryTableQuery, {
	type AggDirectoryViewTableQuery as TeamDirectoryTableQueryType,
} from '../__generated__/AggDirectoryViewTableQuery.graphql';

import { getTeamColumnsToFetchInTql } from './utils';

export const getTeamDirectoryTableResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<TeamDirectoryTableQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const siteId = context.collabContext?.rovoWorkspace || context.workspace?.cloudId || '';
	const scopeId = createPlatformSiteAri(siteId) ?? '';
	const q = routerContext.query.tql || '';
	const selectedStandardColumns = getStandardColumns('teams', routerContext.query.columns);

	return {
		environment: getAggRelayEnvironment(),
		query: TeamDirectoryTableQuery,
		variables: {
			scopeId,
			q,
			...getTeamColumnsToFetchInTql(selectedStandardColumns),
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const teamDirectoryTableResource = createRelayResource<TeamDirectoryTableQueryType>({
	getQuery: getTeamDirectoryTableResourceQuery,
});
